module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_03a.ce7d6a88.jpg";